// extracted by mini-css-extract-plugin
export default {"mainContainer":"SidePanelButton_mainContainer__g1UVp"};